import React, {useEffect, useState} from 'react';
import {Card, CardBody, Col, Container, Progress, Row} from "reactstrap";
import {createEvent, createLevels, creatingEventQuestions} from "./mainFunction"
import logo from "../../assets/img/backgrounds/loading-logo.png"
import character from "../../assets/img/backgrounds/loading-character.png";
import {collection, doc, getDoc, getDocs, query, where} from "firebase/firestore";

import {getDb} from "util/Constants";
import {useHistory} from 'react-router-dom/cjs/react-router-dom.min';

const LoadingScreen = ({ userData,signedInUser }) => {
    const [count, setCount] = useState(0);
    const [meta, setMeta] = useState({});
    const history = useHistory()
    // const [levels, setLevels] = useState([]);
    const db = getDb();

    useEffect(() => {
       
        getQuestionsCount()
        if (userData.levels && userData.eventData) {
            const miniGames = [...userData.levels.cognitive, ...userData.levels.aptitude]

            getmeta().then((meta) => {
                createEvent(userData.eventData, db,signedInUser.uid).then(() => {
                    setCount(10)
                    createLevels(miniGames, userData.eventData.eventId, meta).then(() => {
                        setCount(40)
                        getQuestionsCount().then((result) => {
                            setCount(55)
                            getLevels().then(async (levels) => {
                                setCount(70)
                                const count = creatingEventQuestions(userData.levels.competencies, levels, result, userData.eventData.eventId,userData.eventData.difficulty , pushFunction)

                            })
                        })
                    })
                })
            })

        }

    }, [])

    const getmeta = async () => {
        const docRef = doc(db, "util", "meta");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            return docSnap.data()

        } else {
            // docSnap.data() will be undefined in this case

        }
    }



    const getQuestionsCount = async () => {
        const docRef = doc(getDb(), "MetaData_Questions_Count", "analytics");
        const docSnap = await getDoc(docRef);
        let data = {}
        if (docSnap.exists()) {
            data = docSnap.data();
        } else {

        }
        return data
    }
    const getLevels = async () => {
        const dataArr = [];
        const q = query(
            collection(getDb(), "Levels"),
            where('eventId', '==', userData.eventData.eventId),
            where('tabName', '<', 'Mini')
        );
        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            const data = doc.data();

            dataArr.push({ ...data });

        });
        return dataArr
    }

    const pushFunction = () => {
        setCount(100)
        history.push('/assessment/step4/congratulation')

    }






    return (
        <div>
            <Container>
                <div className="d-flex justify-content-center">
                    <Card className="br-60 mt--75 step1-card">
                        <CardBody className="startCard pt-3">
                            <div className="text-center my-3">
                                <img src={logo} width="100%" />
                            </div>
                            <Row>
                                <Col lg={8}>
                                    <div className="d-flex align-items-end h-100">
                                        <div>
                                            <h2>Adding- Cognitive Ability Assessments</h2>
                                            <div className="mt-3 loading-wrapper mb-lg-5">
                                                <Progress
                                                    className="m-3"
                                                    color="loading-bg"
                                                    value={count}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col lg={4} className="text-center">
                                    <img src={character} />
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </div>
            </Container>
        </div>
    );
};

export default LoadingScreen;